import { FC } from 'react';

import { GridColumn, GridLayout, GridRow } from '@hh.ru/magritte-ui';

import { BannerBuilderActions } from 'components/BannerBuilder/BannerBuilderActions/BannerBuilderActions';
import { BannerForm } from 'components/BannerBuilder/BannerForm/BannerForm';
import { StickyActionBarWrapper } from 'components/common/StickyActionBarWrapper/StickyActionBarWrapper';
import { BannerPreviewSidebar } from 'components/CpcFlexibleCreate/BannerPreviewSidebar/BannerPreviewSidebar';

export const BannerBuilder: FC = () => (
    <StickyActionBarWrapper
        content={
            <GridLayout>
                <GridRow>
                    <GridColumn xs={4} s={8} m={7} l={6}>
                        <BannerForm />
                    </GridColumn>
                    <GridColumn xs={0} l={2} />
                    <GridColumn xs={4} s={8} m={5} l={4}>
                        <BannerPreviewSidebar />
                    </GridColumn>
                </GridRow>
            </GridLayout>
        }
        actionBar={<BannerBuilderActions />}
    />
);
